import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Label } from '@jotta/ui/Label'
import type { FC } from 'react'
import { useState } from 'react'
import type { RadixDialogProps } from '../RadixDialog/RadixDialog'
import { RadixDialog } from '../RadixDialog/RadixDialog'

export interface VerifyEmailOtpDialogProps extends RadixDialogProps {
  destructive?: boolean
  /** Verify button loading state  */
  isLoading?: boolean
  /** Verification handler  */
  onVerify: (value: string) => void
}

export const VerifyEmailOtpDialog: FC<VerifyEmailOtpDialogProps> = ({
  title,
  smallTitle,
  destructive,
  errorMessage,
  isLoading,
  skipCloseButton,
  onClose,
  onVerify,
}) => {
  const [otp, setOtp] = useState<string>('')
  const submitDisabled = !otp
  const onSubmit = () => {
    if (!submitDisabled) {
      onVerify(otp)
    }
  }
  return (
    <RadixDialog
      title={title || t`Authentication Required`}
      errorMessage={errorMessage}
      skipCloseButton={skipCloseButton}
      onClose={onClose}
      buttons={[
        {
          label: t`Cancel`,
          action: 'close',
          type: 'outline',
        },
        {
          label: t`Verify`,
          disabled: submitDisabled,
          loading: isLoading,
          type: destructive ? 'destructive' : 'primary',
          action: onSubmit,
        },
      ]}
    >
      <form onSubmit={onSubmit}>
        <Label>
          {smallTitle || <Trans>Type in authentication code</Trans>}
        </Label>
        <input
          autoFocus
          className="input"
          value={otp}
          onChange={e => setOtp(e.target.value)}
        />
      </form>
    </RadixDialog>
  )
}
